import BaseBusinessAPI from '../portal/baseBusinessAPI'
import httpClient from '@/apis/base/httpclient'

class EnrollmentGroupAPI extends BaseBusinessAPI {
  controllerName = 'EnrollmentGroups';

  getListYearBorn (schoolYear) {
    const request = {
      url: [this.getAPIUrl(), 'list-year-born'].join('/'),
      data: {
        schoolYear: schoolYear,
      },
    }
    return httpClient.getAsync(request)
  }

  /**
   * Lấy thông tin nhóm xét tuyển
   * @param {*} model
   * @returns
   */
  getEnrollmentGroup (model) {
    const request = {
      url: [this.getAPIUrl(), 'enrollment-group'].join('/'),
      data: model,
    }
    return httpClient.getAsync(request)
  }

  /**
   * Lấy tất cả các nhóm của các đợt xét tuyển
   * @param {*} model
   * @returns
   */
  getAllEnrollmentGroup (model) {
    const request = {
      url: [this.getAPIUrl(), 'all-enrollment-group'].join('/'),
      data: model,
    }
    return httpClient.getAsync(request)
  }

  /**
   * Lấy tất cả các nhóm của các đợt xét tuyển cho tính năng xếp lớp
   * @param {*} model
   * @returns
   */
  getEnrollmentGroupsForClassArrangement (model) {
    const request = {
      url: [this.getAPIUrl(), 'class-arrangement-enrollment-groups'].join('/'),
      data: model,
    }
    return httpClient.getAsync(request)
  }
}

export default new EnrollmentGroupAPI()
